module.exports = __webpack_public_path__ + "static/availability-79df9dc54fab3d4ed73d212186768c77.png";